var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Archive1IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 19.0016C21 20.1053 20.1074 21 19.0049 21H4.99509C3.89323 21 3 20.1029 3 19.0016V9C2.44711 9 2 8.54902 2 7.99573V4.99791C2 3.8945 2.89821 3 4.00001 3H20C21.1046 3 22 3.89826 22 4.99791V7.99573C22 8.55037 21.5542 9 21.0014 9L21 19.0016ZM5 9V19H19V9H5ZM4 5V7H20V5H4ZM8 12C8 11.4477 8.44726 11 8.99703 11H15.003C15.5536 11 16 11.4439 16 12C16 12.5523 15.5527 13 15.003 13H8.99703C8.44639 13 8 12.5561 8 12Z", fill: "" })));
}
export var Archive1Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Archive1IconInner }, props))); };
//# sourceMappingURL=Archive1Icon.js.map